import { useEffect, useState } from 'react';
import { PartIdCount, SparePartCount } from '../interfaces/Item';
import { useCart } from '../contexts/Cart';
import { getImageSrc, sparePartService } from '../services';
import { StatusType } from '../interfaces/Cart';

interface SummaryState {
  loading: boolean;
  status: StatusType;
  items: SparePartCount[];
}

export const useSummary = (id: string, token: string): SummaryState => {
  const cartContext = useCart();
  const [status, setStatus] = useState<StatusType>('PENDING');
  const [items, setItems] = useState<SparePartCount[]>(cartContext.getItems());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async (): Promise<void> => {
      try {
        if (id && token) {
          setLoading(true);
          const result = await sparePartService.fetchSparePartOrderId(
            id,
            token
          );
          const cartItemToItemQuantity = (
            item: PartIdCount
          ): SparePartCount => {
            return {
              item: {
                id: item.partId,
                imageSrc: getImageSrc(item.partId),
                replacementId: '',
                stock: 0,
                description: '',
                name: '',
                status: 'AVAILABLE',
                categoryId: '',
                subCategoryId: '',
              },
              quantity: item.quantity,
            };
          };
          const newItems = result.cart.cartItems.map(cartItemToItemQuantity);
          setStatus(result.status);
          setItems(newItems);
        }
      } catch (e) {
        // Do stuff
      } finally {
        setLoading(false);
      }
    })();
  }, [id, token]);

  return { status, loading, items };
};
